<template>
  <!-- 编辑器 -->
  <div style="border: 1px solid #ccc;">
    <Toolbar
      style="border-bottom: 1px solid #ccc;"
      :editor="editor"
      :defaultConfig="toolbarConfig"
      :mode="mode"
    />
    <Editor
      style="height: 250px;  overflow-y: hidden;  text-align: left;"
      v-model="html"
      :defaultConfig="editorConfig"
      :mode="mode"
      @onCreated="onCreated"
    />
  </div>
</template>

<script>
import { Boot } from "@wangeditor/editor";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import attachmentModule from "@wangeditor/plugin-upload-attachment";
Boot.registerModule(attachmentModule);
export default {
  components: { Editor, Toolbar },
  props: {
    content: {
      type: String,
      default: "",
    },
  },
  watch: {
    html(newVal) {
      this.$emit("setHtml", newVal);
    },
  },
  data() {
    return {
      editor: null,
      html: "<p>hello</p>",
      toolbarConfig: {
        insertKeys: {
          index: 0,
          keys: ["uploadAttachment"],
        },
      },
      editorConfig: {
        placeholder: "请输入内容...",
        hoverbarKeys: {
          attachment: {
            menuKeys: ["downloadAttachment"], // “下载附件”菜单
          },
        },
        MENU_CONF: {
          // 配置上传图片
          uploadImage: {
            server: this.$fileBaseurl + "/uploadImageByMultipartFile",
            fieldName: "file",
            meta: {
              systemName: "finance",
              title: "编辑器上传图片",
            },
            headers: {
              token: "95931b371eb64f4a9c862983ca8a5d15",
            },
            customInsert(res, insertFn) {
              console.log("res", res);
              insertFn(res.result.path, res.result.title);
            },
          },
          uploadAttachment: {
            //附件自定义上传
            customUpload: async (file, insertFn) => {
              console.log("file", file);
              let res = await this.uploadFile(file);
              insertFn(file.name, res);
            },
          },
          // 上传视频
          uploadVideo: {
            server: this.$fileBaseurl + "/uploadImageByMultipartFile",
            fieldName: "file",
            meta: {
              systemName: "finance",
              title: "编辑器上传视频",
            },
            headers: {
              token: "95931b371eb64f4a9c862983ca8a5d15",
            },
            customInsert(res, insertFn) {
              console.log("上传视频上传视频上传视频", res);
              insertFn(res.result.path, res.result.title);
            },
          },
          // 继续其他菜单配置...
        },
      },
      mode: "default", // or 'simple'
    };
  },
  methods: {
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
    },
    uploadFile(file) {
      // 上传文件
      let p = new Promise((resolve, reject) => {
        let formData = new FormData();
        formData.append("title", file.name);
        formData.append("file", file);
        this.$requestByFormData(
          "post",
          "/uploadImageByMultipartFile",
          formData,
          (data) => {
            this.$message.success("上传成功");
            resolve(data.path);
          },
          (errorMessage) => {
            this.$message.error(errorMessage);
          },
        );
      });
      return p;
    },
  },
  mounted() {
    // this.editor.txt.html(this.content);
    setTimeout(() => {
      this.html = this.content;
    }, 10);
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
};
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
